var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MC/Confirmed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1765 18.5534V21.0316C21.1765 21.6306 20.9348 22.2051 20.5046 22.6287C20.0743 23.0522 19.4908 23.2902 18.8824 23.2902H5.1181C4.50968 23.2902 3.92618 23.0522 3.49596 22.6287C3.06574 22.2051 2.82405 21.6306 2.82405 21.0316V18.5534H21.1765Z",
    fill: "#F2CA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5884 2.96667H18.8824C19.4908 2.96667 20.0743 3.20463 20.5046 3.6282C20.9348 4.05177 21.1765 4.62626 21.1765 5.22528V21.0355C21.1765 21.6345 20.9348 22.209 20.5046 22.6326C20.0743 23.0561 19.4908 23.2941 18.8824 23.2941H5.1181C4.50968 23.2941 3.92618 23.0561 3.49596 22.6326C3.06574 22.209 2.82405 21.6345 2.82405 21.0355V5.22528C2.82405 4.62626 3.06574 4.05177 3.49596 3.6282C3.92618 3.20463 4.50968 2.96667 5.1181 2.96667H7.41216",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4413 0.705872H8.55914C7.92565 0.705872 7.41211 1.21148 7.41211 1.83517V4.09378C7.41211 4.71747 7.92565 5.22308 8.55914 5.22308H15.4413C16.0748 5.22308 16.5883 4.71747 16.5883 4.09378V1.83517C16.5883 1.21148 16.0748 0.705872 15.4413 0.705872Z",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250847",
    d: "M10.1268 12.9787L11.5032 14.4423L14.409 11.8077",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1025",
    cx: 12.0006,
    cy: 13.1257,
    rx: 4.01459,
    ry: 3.95256,
    stroke: "#383434",
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/Confirmed.18dc3ac1fc8e2af57dd7c35e06cbcbc0.svg";
export { ForwardRef as ReactComponent };